var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuButtonGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2626_6496",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000549316,
    y: 0.182373,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2626_6496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.00055 18.1824V16.1824H21.0005V18.1824H3.00055ZM3.00055 13.1824V11.1824H21.0005V13.1824H3.00055ZM3.00055 8.18237V6.18237H21.0005V8.18237H3.00055Z",
    fill: "#686973"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButtonGray);
export default __webpack_public_path__ + "static/media/menuButtonGray.5c7b4516799938ee370a77059c11a6ff.svg";
export { ForwardRef as ReactComponent };